<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pt-0 pb-3"
        *ngIf="orderTrackingGridListing.length > 5 || forModalStacker">
        <span class="col-auto">
          <h2 class="mb-0">
            Order Tracking Listing
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>

        <span class="d-flex gap-3 customizefilter-btn align-items-center">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />

          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          responsiveLayout="scroll"
          [value]="orderTrackingGridListing"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="orderTrackingGridListing.length > 5"
          [filterDelay]="0">
          <ng-template pTemplate="header">
            <tr>
              <th class="number">Ship Date</th>
              <th class="status">Carrier</th>
              <th class="name">Tracking</th>
              <th class="jname">Weight</th>
              <th class="buyer">Sale Price</th>
              <th class="buyer">Ship Method</th>
              <th class="buyer">Shipper Name</th>
              <th class="buyer">Recipient Name</th>
              <th class="inhanddate">Shipped From</th>
              <th class="date-time">Shipped To</th>
              <th class="subtotal">Reference Fields</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-orderTrackingGridListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="orderTrackingGridListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="number">
                <span
                  *ngIf="orderTrackingGridListing?.ShipDate | hidedynamicsdate">
                  {{ orderTrackingGridListing?.ShipDate | date: "MM-dd-yyyy" }}
                </span>
              </td>
              <td class="status">
                {{ orderTrackingGridListing?.Carrier }}
              </td>
              <td class="name">
                <a
                  class="link"
                  (click)="
                    onTrackingNumberSelection(
                      orderTrackingGridListing?.TrackingNumber
                    )
                  ">
                  {{ orderTrackingGridListing?.TrackingNumber }}
                </a>
              </td>
              <td class="jname">
                {{ orderTrackingGridListing?.Weight | number: "1.2-2" }}
              </td>
              <td
                class="buyer"
                [ngClass]="{
                  'highlight-sellprice':
                    orderTrackingGridListing?.SellPrice === 0,
                }">
                {{
                  orderTrackingGridListing?.SellPrice
                    | currency: "USD" : "symbol" : "0.2-2"
                }}
              </td>
              <td class="inhandate">
                {{ orderTrackingGridListing?.DlvModeDescription || "" }}
              </td>
              <td class="inhandate">
                {{ orderTrackingGridListing?.ShipperName || "" }}
              </td>
              <td class="inhandate">
                {{ orderTrackingGridListing?.RecipientName || "" }}
              </td>
              <td class="inhandate">
                {{ orderTrackingGridListing?.ShipFromAddress || "" }}
              </td>
              <td class="date-time">
                {{ orderTrackingGridListing?.ShipToAddress }}
              </td>
              <td class="subtotal">
                {{ orderTrackingGridListing?.JNIReference }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No order tracking found.</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="text-left">{{ totalSalePrice | currency: "USD" }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders pagination-order">
  <div
    *ngIf="orderTrackingGridListing.length > 5"
    class="orders-header d-flex align-items-center justify-content-between has-border py-2 mb-4">
    <h1>Order Tracking</h1>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </div> -->

<!-- <jni-modal-stacker
  *ngIf="orderTrackingDisplayModal"
  [displayModal]="orderTrackingDisplayModal"
  (closeEvent)="closeModalFromOrderTracking()"
>
  <h1 class="panelHeading">Order Tracking Listing</h1>
  <div class="panelBody">
    <jni-invoice-preview-order-tracking-line
      [trackingNumber]="trackingNumber"
      (scrollHiddenStatus)="addScollHiddenClass()"
    ></jni-invoice-preview-order-tracking-line>
  </div>
</jni-modal-stacker> -->

<jni-modal-stacker
  *ngIf="orderTrackingDisplayModal"
  [displayModal]="orderTrackingDisplayModal"
  (closeEvent)="closeModalFromOrderTracking()">
  <h1 class="panelHeading">Freight Details</h1>
  <div class="panelBody">
    <jni-freight-details
      [isModal]="true"
      [trackingNumber]="trackingNumber"
      (closeEvent)="closeModalFromOrderTracking()"></jni-freight-details>
  </div>
</jni-modal-stacker>
